import { render, staticRenderFns } from "./EditBadgesTable.vue?vue&type=template&id=28bf280a&scoped=true"
import script from "./EditBadgesTable.ts?vue&type=script&lang=ts&external"
export * from "./EditBadgesTable.ts?vue&type=script&lang=ts&external"
import style0 from "./EditBadgesTable.vue?vue&type=style&index=0&id=28bf280a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf280a",
  null
  
)

export default component.exports